import { EnrollmentContextResponseDto } from 'theSource/queries';
import { ContextCard } from './components';

interface EnrollmentBoxProps {
  contexts?: EnrollmentContextResponseDto;
}

export const EnrollmentBox = ({ contexts }: EnrollmentBoxProps) => {
  let activeContexts = [];
  if (contexts?.data?.length) {
    activeContexts = contexts.data.filter(
      (context) => context.status !== 'not_open'
    );
  }
  if (!activeContexts.length) {
    return null;
  }

  let contextWrapperClass = activeContexts.length > 1 ? 'dual' : 'single';

  if (
    contexts?.data?.length === 1 &&
    contexts.data[0].enrollment_type_lookup_code === 'life_event'
  ) {
    const addPlanYear =
      contexts.data[0].included_plan_years.length > 1 &&
      contexts.data[0].status === 'complete';
    const dualPYLifeEvent =
      contexts.data[0].subscriber_life_event?.org_plan_year_ids &&
      contexts.data[0].subscriber_life_event?.org_plan_year_ids.length > 1;

    contextWrapperClass = addPlanYear || dualPYLifeEvent ? 'dual' : 'single';
  }

  if (contexts === undefined) {
    return null;
  }

  return (
    <div className={`d-md-flex contexts ${contextWrapperClass}`}>
      {contexts.data.map((context, index) => {
        return (
          <ContextCard
            key={index}
            enrollmentContext={context}
            cardIndex={index}
            allContexts={contexts.data}
          />
        );
      })}
    </div>
  );
};
